import { DomComponentHander } from "./Handler";
export class DisableDuplicateSubmit extends DomComponentHander {
    static DomContentLoaded() {
        document.querySelectorAll('form').forEach(form => {
            form.addEventListener('submit', () => {
                const button = form.querySelector('button[type="submit"]');
                button.disabled = true;
                setTimeout(() => {
                    button.disabled = false;
                }, 5000);
            });
        });
    }
}
